import { DownloadResultLimiter } from "@/services/license/license-limiters/base-limiters/download-result-limiter";
import { LicenseName } from "@/data/license.data";

export class DefaultDownloadResultLimiter extends DownloadResultLimiter {
  isDownloadEnabled(license: LicenseName) {
    return true;
  }
}
